<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <div class="relative">
    <div
      class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-4 transition relative z-10 "
      :class="{'-ml-32': active, 'ml-24': isActive || isLeft}"
    >
      <div
        class="w-10 h-10 absolute pin-t pin-l rounded-full -mt-2 -ml-2 z-1"
        :class="'bg-' + evaluateMinor"
      ></div>
      <div class=" flex flex-col justify-between leading-normal relative z-3 w-full">
        <div class="flex items-center">
          <div v-if="(getRole('teacher') || (getRole('tutor') && minor.isFamilyAdmin))">
            <router-link
              class="h-120 w-120"
              :to="{name: 'MinoreDettaglio', params: { 'id': minor.id }}"
            >
              <img
                class="rounded-full mr-3 border-4 h-120 w-120 -mb-2 -mt-1"
                :class="'border-' + evaluateMinor"
                :src="'/img/user.png'"
              >
            </router-link>
          </div>
          <div v-if="!(getRole('teacher') || (getRole('tutor') && minor.isFamilyAdmin))">
            <img
              class="rounded-full mr-3 border-4 h-120 w-120 -mb-2 -mt-1"
              :class="'border-' + evaluateMinor"
              :src="'/img/user.png'"
            >
          </div>
          <div
            class="text-sm w-full xs:pl-2 xs:pr-4 sm:px-5"
            v-touch:swipe.left="swipeLeftHandler"
            v-touch:swipe.right="swipeRightHandler"
            v-touch:tap="swipeHandler">
            <h3 :class="evaluateMinor === 'blinkingBlue' ?  'text-blue' : evaluateMinor === 'flipDanger'? 'text-red' : evaluateMinor === 'grey-darkest' ? 'text-grey' : 'text-' + evaluateMinor">{{ minor.name }} {{ minor.surname }}</h3>
            <div v-if="getRole('teacher')">
              <p><span :class="evaluateMinor === 'blinkingBlue' ?  'text-blue' : evaluateMinor === 'flipDanger'? 'text-red' : evaluateMinor === 'grey-darkest' ? 'text-grey' : 'text-' + evaluateMinor">{{ showMessage }}</span></p>
              <p
                v-if="this.minor.status === 'danger'"
                class="text-red"
              ><i>{{$t('all.time_limit_exceeded')}}</i></p>
              <p
                v-if="this.minor.status != 'danger'"
                class="text-grey-light"
              ><i>{{ getTimeLimit }}</i></p>
              <div
                v-if="this.minor.status === 'danger'"
                class="text-white absolute pin-t pin-r bg-red rounded-full -mt-6 -mr-6 z-1"
                style="top: 50%"
              >
                <i class="fas fa-exclamation-circle p-3 text-2xl"></i>
              </div>
            </div>
            <div v-if="getRole('tutor')">
              <p class="italic">{{ minor.scuola }}</p>
              <p class="text-grey-light"> {{$t('all.class').toUpperCase()}} {{ classroom.class_name }} </p>
              <p><span :class="evaluateMinor === 'blinkingBlue' ?  'text-blue' : evaluateMinor === 'flipDanger'? 'text-red' : evaluateMinor === ' grey-darkest' ? 'text-grey' : 'text-' + evaluateMinor">{{ showMessage }}</span></p>
              <div
                class="text-white absolute pin-t pin-r bg-red rounded-full -mt-6 -mr-6 z-1"
                style="top: 50%"
                @click="qrCode(minor)"
              >
                <i class="fas fa-qrcode p-3 text-2xl"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="menuItem === `${$t('all.class_appeal')}` && getRole('teacher')"
      class="bg-green absolute h-full w-2/3 pin-t pin-r z-2 transition cursor-pointer"
      @click="confirmPresence"
      :class="{'-mr-8': active}"
    >
      <p class="text-right pr-10 mr-3 uppercase text-white pt-8">
        {{$t('all.present')}}
      </p>
    </div>
    <div
      v-if="getRole('teacher')"
      class="bg-purple absolute h-full w-1/3 pin-t pin-l ml-8 z-2 transition cursor-pointer"
      @click="confirmAbsence"
      :class="{'-ml-8': isActive, 'w-2/3': isActive}"
    >
      <p class="text-left pl-8 uppercase text-white pt-8">
        {{$t('all.absent')}}
      </p>
    </div>
    <div
      v-if="menuItem === `${$t('all.kids_in_class')}`  && getRole('teacher')"
      class="bg-purple absolute h-full w-1/3 pin-t pin-l ml-8 z-2 transition cursor-pointer"
      @click="confirmLeft"
      :class="{'-ml-8': isLeft, 'w-2/3': isLeft}"
    >
      <p class="text-left pl-8 uppercase text-white pt-8">
        {{$t('all.uscita')}}
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import get from 'lodash';
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import {
  evaluateMinor,
  showMinorMessage,
  getMinorTimeLimit,
} from '@/mixins/minore.mixins';

export default {
  props: ['minor', 'menuItem'],
  mixins: [evaluateMinor, showMinorMessage, getMinorTimeLimit],
  data() {
    return {
      active: false,
      isActive: false,
      isLeft: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedClass: 'classi/selectedClass',
      userInfo: 'authentication/userInfo',
    }),
    classroom() {
      return get(this.minor, ['classroom']) || {};
    },
  },
  methods: {
    ...mapActions('users', [
      'changeMinorStatus',
      'confirmAbsenceAction',
      'confirmLeftAction',
    ]),
    ...mapActions('authentication', ['getUserInfo']),

    swipeLeftHandler() {
      if (
        authService.hasRole('teacher') &&
        this.menuItem === `${this.$t('all.class_appeal')}`
      ) {
        if (this.active === false && this.isActive === false) {
          this.isActive = false;
          this.active = true;
        } else {
          this.isActive = false;
          this.active = false;
        }
        this.isLeft = false;
      }
    },
    swipeRightHandler() {
      if (
        authService.hasRole('teacher') &&
        this.menuItem === `${this.$t('all.class_appeal')}` &&
        this.minor.status_description !== 'qr_arrived'
      ) {
        this.isLeft = false;
        if (this.active === false && this.isActive === false) {
          this.isActive = true;
        }
      }
      if (
        authService.hasRole('teacher') &&
        this.menuItem === `${this.$t('all.kids_in_class')}` &&
        this.minor.status_description !== 'minor_left_class'
      ) {
        this.isLeft = true;
      }
    },
    swipeHandler() {
      this.isActive = false;
      this.active = false;
      this.isLeft = false;
    },
    tapHandler() {
      if (authService.hasRole('teacher')) {
        this.active = !this.active;
      }
    },
    confirmPresence() {
      if (authService.hasRole('teacher')) {
        const id = this.minor.id;
        this.changeMinorStatus({
          id,
          classroom: this.$route.params.id,
        });
        this.active = false;
      }
    },
    confirmAbsence() {
      if (authService.hasRole('teacher')) {
        const id = this.minor.id;
        this.confirmAbsenceAction({
          id,
          classroom: this.$route.params.id,
        });
        this.isActive = false;
      }
    },
    confirmLeft() {
      if (authService.hasRole('teacher')) {
        const id = this.minor.id;
        this.confirmLeftAction({
          id,
          classroom: this.$route.params.id,
        });
        this.isLeft = false;
      }
    },
    getRole(role) {
      // check ruolo
      return authService.hasRole(role);
    },

    qrCode(minor) {
      this.$router.push({
        name: 'QrCode',
        query: { fullname: minor.name + ' ' + minor.surname },
        params: { id: minor.id },
      });
    },
  },
  async created() {
    await this.getUserInfo();
  },
};
</script>
